import type {TalentPoolActions} from 'src/action-creators/talent-pools/talent-pools';
import type {
  TalentPoolListSuggestion,
  TalentPoolList,
  TalentPoolUsersResponse,
  TalentPoolFolder,
  TalentPoolCandidate,
  TalentPoolHierarchy,
} from 'src/types/talent-pools';
import {
  TALENT_POOL_LIST,
  TALENT_POOL_LIST_ERROR,
  TALENT_POOL_USERS_SEARCH,
  TALENT_POOL_USERS_SEARCH_ERROR,
  TALENT_POOL_DETAILS,
  TALENT_POOL_DETAILS_ERROR,
  TALENT_POOL_FOLDERS,
  TALENT_POOL_FOLDERS_ERROR,
  TALENT_POOL_FOLDER_DETAILS,
  TALENT_POOL_FOLDER_DETAILS_ERROR,
  TALENT_POOL_FOLDERS_HIERARCHY,
  TALENT_POOL_FOLDERS_HIERARCHY_ERROR,
} from 'src/action-creators/talent-pools/talent-pools';
import {
  TALENT_POOL_LIST_SUGGESTION,
  TALENT_POOL_LIST_SUGGESTION_ERROR,
} from 'src/action-creators/talent-pools/talent-pool-suggestion';
import {
  TALENT_POOL_CANDIDATE,
  TALENT_POOL_CANDIDATE_ERROR,
  TRM_APPLICANTS,
  TRM_APPLICANTS_ERROR,
} from 'src/action-creators/talent-pools/candidate';


export type TalentPoolsState = {
  talentPoolListSuggestion: TalentPoolListSuggestion | null | undefined;
  talentPoolList: TalentPoolList | null | undefined;
  talentPoolUsers: TalentPoolUsersResponse | null | undefined;
  talentPoolDetails: TalentPoolFolder | null | undefined;
  talentPoolFolders: TalentPoolList | null | undefined;
  talentPoolCandidate: TalentPoolCandidate | null | undefined;
  trmApplicants: TalentPoolCandidate | null | undefined;
  talentPoolFolderDetails: TalentPoolFolder | null | undefined;
  talentPoolFoldersHierarchy: TalentPoolHierarchy | null | undefined;
};

const initialState: TalentPoolsState = {
  talentPoolListSuggestion: null,
  talentPoolList: null,
  talentPoolUsers: null,
  talentPoolDetails: null,
  talentPoolFolders: null,
  talentPoolCandidate: null,
  trmApplicants: null,
  talentPoolFolderDetails: null,
  talentPoolFoldersHierarchy: null,
};

export default function talentPoolsReducer(
  state: TalentPoolsState | null | undefined = initialState,
  action: TalentPoolActions,
): TalentPoolsState {
  switch (action.type) {
    case TALENT_POOL_LIST_SUGGESTION:
      // @ts-expect-error - TS2322 - Type '{ talentPoolListSuggestion: TalentPoolListSuggestion; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolListSuggestion: action.payload};
    case TALENT_POOL_LIST_SUGGESTION_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolListSuggestion: null; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; talentPoolDetails?: TalentPoolFolder | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolListSuggestion: null,
      };
    case TALENT_POOL_LIST:
      // @ts-expect-error - TS2322 - Type '{ talentPoolList: TalentPoolList; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolList: action.payload};
    case TALENT_POOL_LIST_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolList: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; talentPoolDetails?: TalentPoolFolder | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolList: null,
      };
    case TALENT_POOL_USERS_SEARCH:
      // @ts-expect-error - TS2322 - Type '{ talentPoolUsers: TalentPoolUsersResponse; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolUsers: action.payload};
    case TALENT_POOL_USERS_SEARCH_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolUsers: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolDetails?: TalentPoolFolder | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolUsers: null,
      };
    case TALENT_POOL_DETAILS:
      // @ts-expect-error - TS2322 - Type '{ talentPoolDetails: TalentPoolFolder; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolDetails: action.payload};
    case TALENT_POOL_DETAILS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolDetails: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolDetails: null,
      };
    case TALENT_POOL_FOLDERS:
      // @ts-expect-error - TS2322 - Type '{ talentPoolFolders: TalentPoolList; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolFolders: action.payload};
    case TALENT_POOL_FOLDERS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolFolders: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolFolders: null,
      };
    case TALENT_POOL_CANDIDATE:
      // @ts-expect-error - TS2322 - Type '{ talentPoolCandidate: TalentPoolCandidate; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolCandidate: action.payload,
      };
    case TALENT_POOL_CANDIDATE_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolCandidate: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolCandidate: null,
      };
    case TRM_APPLICANTS:
      // @ts-expect-error - TS2322 - Type '{ trmApplicants: TalentPoolCandidate; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, trmApplicants: action.payload};
    case TRM_APPLICANTS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ trmApplicants: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        trmApplicants: null,
      };
    case TALENT_POOL_FOLDER_DETAILS:
      // @ts-expect-error - TS2322 - Type '{ talentPoolFolderDetails: TalentPoolFolder; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolFolderDetails: action.payload};
    case TALENT_POOL_FOLDER_DETAILS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolFolderDetails: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 4 more ...; talentPoolFoldersHierarchy?: TalentPoolHierarchy | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolFolderDetails: null,
      };
    case TALENT_POOL_FOLDERS_HIERARCHY:
      // @ts-expect-error - TS2322 - Type '{ talentPoolFoldersHierarchy: TalentPoolHierarchy; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; ... 5 more ...; talentPoolFolderDetails?: TalentPoolFolder | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {...state, talentPoolFoldersHierarchy: action.payload};
    case TALENT_POOL_FOLDERS_HIERARCHY_ERROR:
      // @ts-expect-error - TS2322 - Type '{ talentPoolFoldersHierarchy: null; talentPoolListSuggestion?: TalentPoolListSuggestion | null | undefined; talentPoolList?: TalentPoolList | null | undefined; talentPoolUsers?: TalentPoolUsersResponse | null | undefined; ... 4 more ...; talentPoolFolderDetails?: TalentPoolFolder | null | undefined; }' is not assignable to type 'TalentPoolsState'.
      return {
        ...state,
        talentPoolFoldersHierarchy: null,
      };
    default:
      // @ts-expect-error - TS2322 - Type 'TalentPoolsState | null' is not assignable to type 'TalentPoolsState'.
      return state;
  }
}
